import React from 'react';
import { Box, useMediaQuery } from '@mui/material';
import Button from '../../../components/Button';
import SearchBox from '../../../components/SearchBox';
import AddIcon from '@mui/icons-material/Add';
import Star from '@mui/icons-material/Star';
import useStore from '../../../Store/Store';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
const TopBar = ({ btnText = 'Add Diagnosis', onClick, onChange }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const features = useStore((state) => state.features);
  return (
    <Box
      display="flex"
      width="100%"
      alignItems="center"
      justifyContent="space-between"
      position="relative"
      padding="0 16px"
      sx={{
        '@media (max-width: 768px)': {
          flexDirection: 'column',
          alignItems: 'center',
          gap: 2,
        },
      }}
    >
      <div style={{ width: isMobile ? '90%' : 'auto' }}>
        {features.crSearchbar && (btnText === t('addDiagnosis') || btnText === t('addAllergy')) && (
          <SearchBox onChange={onChange} />
        )}
        {btnText === t('addMedication') && (
          <Button
            startIcon={<Star />}
            text={t('medicationIntakeStatistics')}
            bg="light"
            onClick={onClick}
            fullWidth={isMobile}
          />
        )}
      </div>

      <Box display="flex" gap={3} width={isMobile ? '90%' : 'auto'}>
        <Button fullWidth={isMobile} startIcon={<AddIcon />} text={btnText} onClick={onClick} />
      </Box>
    </Box>
  );
};

export default TopBar;
